import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByProvince = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByProvince }
  } = localizedStrings;
  const [provinceList, setProvinceList] = useState([]);

  useEffect(() => {
    const getProvinces = async () => {
      const result = await request.get('/provinces');
      if (result) {
        const transformedResult = _.get(result, 'data.provinces', []).map(
          item => ({
            label: item.name,
            value: item.id
          })
        );
        setProvinceList(transformedResult);
      }
    };
    getProvinces();
  }, []);

  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-province' }}>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, province: value });
        }}
        label={filterByProvince}
        options={provinceList}
        value={filters.province}
      />
    </div>
  );
};

FilterByProvince.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByProvince;
